<template>
	<div
		class="t-labeled-value"
		:class="{ horizontal: horizontal }"
	>
		<div
			class="label"
			:class="{ horizontal: horizontal }"
			:style="{ marginBottom: labelMarginBottom }"
		>
			{{ label }}
		</div>
		<div
			class="value"
			:class="{ horizontal: horizontal }"
			:title="toolTipText"
		>
			<slot>{{ valueText }}</slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TLabeledValue',
	props: {
		label: {
			type: String
		},
		value: {
			type: [String, Number],
			default: ''
		},
		fallBackValue: {
			type: [String, Number],
			default: 'N/A'
		},
		tooltip: {
			type: [String, Number],
			default: ''
		},
		labelMarginBottom: {
			type: String,
			default: '3px'
		},
		horizontal: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		valueText() {
			return (this.value === undefined || this.value === null)
				? this.fallBackValue
				: this.value;
		},
		toolTipText() {
			return (this.tooltip === undefined || this.tooltip === null)
				? this.value
				: this.tooltip;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
.t-labeled-value {
	box-sizing: border-box;

	&.horizontal {
		display: flex;
		align-items: baseline;
	}
}
.label {
	user-select: none;
	font-size: 11px;
	font-weight: 600;
	line-height: 1.45;
	letter-spacing: 0.3px;
	color: get-color($text, 'dark');
	text-transform: uppercase;

	&.horizontal {
		text-transform: none;
		font-size: 14px;
		font-weight: 400;
		letter-spacing: normal;
		color: get-color($text, 'default');
		margin-right: 4px;
	}
}
.value {
	margin-left: 1px;
	color: get-color($text, 'default');
	overflow: hidden;
	text-overflow: ellipsis;

	&.horizontal {
		font-weight: 600;
	}
}
</style>

<docs>
```jsx
<div style="display: grid; grid-column-gap: 20px; grid-row-gap: 20px; grid-auto-flow: column; grid-auto-columns: max-content; grid-template-rows: auto auto;">
	<t-labeled-value label="Label" value="Value"/>

	<t-labeled-value label="Label Horizontal:" value="Value Horizontal" horizontal/>
</div>
```
</docs>
